var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97973 9.10824L1.93988 1.06835C1.72035 0.848879 1.3639 0.848879 1.14437 1.06835C0.924858 1.28796 0.924858 1.64436 1.14437 1.86383L9.18424 9.90375L1.14437 17.9436C0.924858 18.1631 0.924858 18.5196 1.14437 18.7391C1.3639 18.9586 1.72035 18.9586 1.93988 18.7391L9.97973 10.6992L18.0196 18.7391C18.2391 18.9586 18.5955 18.9586 18.8151 18.7391C19.0346 18.5196 19.0346 18.1631 18.8151 17.9436L10.7752 9.90375L18.8151 1.86383C19.0346 1.64436 19.0346 1.28796 18.8151 1.06835C18.5955 0.848879 18.2391 0.848879 18.0196 1.06835L9.97973 9.10824Z",
    fill: "var(--primary-text-color, #313639)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/Icon_close.fb19e492.svg";
export { ForwardRef as ReactComponent };